export default [
    {
        path: 'livro-talidomida',
        component: () => import(
            /* webpackChunkName: 'farmacia-livro-talidomida' */
            '@/views/farmacia/livro-talidomida/Index'
        ),
        redirect: 'livro-talidomida/index',
        children: [
            {
                name: 'farmacia-livro-talidomida-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-livro-talidomida' */
                    '@/views/farmacia/livro-talidomida/List.vue'
                ),
            },
            {
                name: 'farmacia-livro-talidomida-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'farmacia-livro-talidomida' */
                    '@/views/farmacia/livro-talidomida/Form.vue'
                ),
            },
            {
                name: 'farmacia-livro-talidomida-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'farmacia-livro-talidomida' */
                    '@/views/farmacia/livro-talidomida/Form.vue'
                ),
            },
        ],
    },
]